import React, { useState, useEffect } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";

const UsersLayout = () => {
  const [users, setUsers] = useState([]);
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);

  const breadcrumb = {
    current_section: "Elenco admin",
    sections: [
      { name: "Utenti", route_name: null, params: [] },
      { name: "Elenco admin", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchools(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchools();
  }, []);

  const handleSearch = async () => {
    const fetchUsers = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllAdmins?schoolId=${selectedSchool}`,
          fetchOptions
        );
        const result = await response.json();
        if (!result.error) {
          setUsers(result);
        } else {
          setUsers([]);
          console.error("Error fetching users:", result.message);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchUsers();
  };

  const handleDelete = async (userId) => {
    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      [],
      "DELETE"
    );
    try {
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/deleteAdmin?adminId=${userId}`,
        fetchOptions
      );
      const result = await response.json();
      if (!result.error) {
        setUsers(users.filter((user) => user.id !== userId));
      } else {
        console.error("Error deleting user:", result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleResetPassword = async (userId) => {
    const fetchOptions = getFetchOptions(
      "application/json",
      { adminId: userId },
      "POST"
    );
    try {
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/sendResetPasswordEmail`,
        fetchOptions
      );
      const result = await response.json();
      if (!result.error) {
        alert("Email di reset password inviata con successo.");
      } else {
        console.error("Error sending reset password email:", result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container-fluid">
      <Breadcrumb breadcrumb={breadcrumb} />
      <div className="card custom-card">
        <div className="card-header card-title">Cerca per scuola</div>
        <div className="card-body">
          <div className="row">
            <div className="col-8">
              <div className="form-group">
                <Select
                  options={schools}
                  id="school"
                  name="school"
                  value={schools?.filter(function (option) {
                    return option.value === selectedSchool;
                  })}
                  onChange={(e) => {
                    setSelectedSchool(e?.value);
                  }}
                  classNames={"form-control"}
                  placeholder="Scegli scuola..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>
            <div className="col-4 d-flex justify-content-end align-items-center">
              <button
                id="btnSearch"
                name="btnSearch"
                className="btn btn-success searchButton"
                type="button"
                onClick={handleSearch}
              >
                &nbsp;Cerca
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Users List Card */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Elenco Admin per scuola</div>
            <div>
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    window.location.href = `/users/add?schoolId=${selectedSchool}`;
                  }}
                  type="button"
                  className="btn btn-primary text-uppercase"
                >
                  <i className="bi bi-plus-circle-fill"></i> Nuovo
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive" id="table_result">
            <table
              className="table text-nowrap table-bordered"
              id="datatable-basic"
            >
              <thead>
                <tr>
                  <th scope="col" width="10">
                    #
                  </th>
                  <th scope="col">Scuola</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Email</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {users &&
                  users?.map((user, index) => (
                    <tr key={index}>
                      <td>{user.id}</td>
                      <td>{user.School?.denomistituto}</td>
                      <td>{user.nominativo}</td>
                      <td>{user.email}</td>
                      <td>
                        <div className="btn-list">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => {
                              window.location.href = `/users/edit/${user.id}`;
                            }}
                          >
                            <i className="align-middle bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Sei sicuro di voler eliminare questo utente?"
                                )
                              ) {
                                handleDelete(user.id);
                              }
                            }}
                          >
                            <i className="align-middle bi bi-trash"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Sei sicuro di voler inviare la mail di reset password a questo utente?"
                                )
                              ) {
                                handleResetPassword(user.id);
                              }
                            }}
                          >
                            <i className="align-middle bi bi-send"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersLayout;
